<div class="my-7">
  <mat-form-field appearance="outline" class="moneytor-input textarea" [ngClass]="class">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <textarea
      matInput
      [name]="name"
      [placeholder]="placeholder"
      [required]="required"
      [(ngModel)]="model"
      [disabled]="disabled"
      [rows]="rows"
      (ngModelChange)="onModelChange($event)"
      #txtArea="ngModel"
    ></textarea>
  </mat-form-field>
  @if (txtArea.invalid && txtArea.touched) {
    <div>
      @if (txtArea.hasError('required')) {
        <mat-error>This field is required*</mat-error>
      }
    </div>
  }
</div>
